export const feedMappingSchema = {
  title: 'Feed Mapping',
  type: 'object',
  required: ['type', 'mapping'],
  properties: {
    type: { type: 'string', title: 'Type' },
    mapping: {
      type: 'object',
      title: 'Mapping',
      properties: {
        columns: {
          type: 'object',
          title: 'Columns',
          properties: {
            inventoryId: { type: 'number' },
            id: { type: 'number' },
            stock: { type: 'number' },
            year: { type: 'number' },
            make: { type: 'number' },
            model: { type: 'number' },
            body: { type: 'number' },
            trim: { type: 'number' },
            condition: { type: 'number' },
            certified: { type: 'number' },
            mileage: { type: 'number' },
            price: { type: 'number' },
            msrp: { type: 'number' },
            invoice: { type: 'number' },
            bookValue: { type: 'number' },
            cost: { type: 'number' },
            intColorCode: { type: 'number' },
            intColor: { type: 'number' },
            extColorCode: { type: 'number' },
            extColor: { type: 'number' },
            cityMpg: { type: 'number' },
            highwayMpg: { type: 'number' },
            engine: { type: 'number' },
            driveTrain: { type: 'number' },
            dateInStock: { type: 'number' },
            daysInStock: { type: 'number' },
            inTransit: { type: 'number' },
            modelCode: { type: 'number' },
            aep: { type: 'number' },
          },
        },
        delimited: {
          type: 'object',
          title: 'Delimited Columns',
          properties: {
            carImg: {
              type: 'object',
              properties: {
                column: { type: 'number' },
                delimiter: { type: 'string' },
              },
            },
            dealerImgList: {
              type: 'object',
              properties: {
                column: { type: 'number' },
                delimiter: { type: 'string' },
              },
            },
            options: {
              type: 'object',
              properties: {
                column: { type: 'number' },
                delimiter: { type: 'string' },
              },
            },
            factoryCodes: {
              type: 'object',
              properties: {
                column: { type: 'number' },
                delimiter: { type: 'string' },
              },
            },
            optionCodes: {
              type: 'object',
              properties: {
                column: { type: 'number' },
                delimiter: { type: 'string' },
              },
            },
          },
        },
      },
    },
  },
};

export const uiSchema = {
  inventoryId: {
    'ui:help':
      'To reference a dealer within a common feed mapping for multiple dealers',
  },
};
